import { Inject, Injectable, InjectionToken } from '@angular/core';
import { WasmGitService, WorkerActionParams } from '@y42/git/worker';
import { FeatureGitWorkerAction } from './worker/actions/feature-git-worker-actions.enum';
import type { FSHydrateStoresAction, FSHydrateStoresActionFn } from './worker/actions/fs-hydrate-stores';
import type { FSReadGitStoreModelAction, FSReadGitStoreModelActionFn } from './worker/actions/fs-read-git-store-model';
import type {
  FSReadGitStoreModelsAction,
  FSReadGitStoreModelsActionFn,
} from './worker/actions/fs-read-git-store-models';
import type { FSReadStoreModelAction, FSReadStoreModelActionFn } from './worker/actions/fs-read-store-model';

export const FEATURE_WASM_GIT_WEB_WORKER = new InjectionToken<Worker>('FeatureWasmGitWebWorker');

@Injectable({ providedIn: 'root' })
export class FeatureWasmGitService extends WasmGitService {
  constructor(@Inject(FEATURE_WASM_GIT_WEB_WORKER) featureWasmGitWebWorker: Worker) {
    super(featureWasmGitWebWorker);
  }

  async readStoreModel(params: WorkerActionParams<FSReadStoreModelAction>) {
    return await this.call<FSReadStoreModelAction, typeof FSReadStoreModelActionFn>({
      type: FeatureGitWorkerAction.ReadStoreModel,
      params,
    });
  }

  async readGitStoreModel(params: WorkerActionParams<FSReadGitStoreModelAction>) {
    return await this.call<FSReadGitStoreModelAction, typeof FSReadGitStoreModelActionFn>({
      type: FeatureGitWorkerAction.ReadGitStoreModel,
      params,
    });
  }

  async readGitStoreModels(params: WorkerActionParams<FSReadGitStoreModelsAction>) {
    return await this.call<FSReadGitStoreModelsAction, typeof FSReadGitStoreModelsActionFn>({
      type: FeatureGitWorkerAction.ReadGitStoreModels,
      params,
    });
  }

  async hydrateStores(params: WorkerActionParams<FSHydrateStoresAction>) {
    return await this.call<FSHydrateStoresAction, typeof FSHydrateStoresActionFn>({
      type: FeatureGitWorkerAction.HydrateStores,
      params,
    });
  }
}
